import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {
  Button,
  Modal,
  Form,
  Col,
} from 'react-bootstrap';
import DNS from 'components/DNS/dns.js';
import NotificationAlert from 'react-notification-alert';
import CircularProgress from '@mui/material/CircularProgress';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';


const ModalDELETETableList = ({showModal, setShowModal, getAppointment, appointmentpk, showVisitor, showHour, showDate}) => {
  const {t} = useTranslation();
  const token = useSelector((state) => state.token);
  const currentBuilding = useSelector((state) => state.currentBuilding);
  const [loading, setLoading] = useState(false);

  const notificationAlertRef = React.useRef(null);
  const notify = (place) => {
    const type = 'success';
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>{t(translations.APPOINTMENT_DELETE2)}</p>
          </div>
        </div>
      ),
      type: type,
      icon: 'nc-icon nc-check-2',
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const DeleteAppointment = (event) => {
    event.preventDefault();
    const requestOptions = {
      method: 'DELETE',
      headers: {'Content-Type': 'application/json', 'Authorization': 'token ' + token['tokenRedux']},
      body: JSON.stringify({'pk': appointmentpk}),
    };
    setLoading(true);
    fetch(DNS + '/list/deleteGetPatchAppointment/' + currentBuilding['currentbuildingRedux'].pk + '/', requestOptions)
        .then(async (response) => {
          const data = await response.json();
          setLoading(false);
          if (data.status == 'OK') {
            notify('tc');
            setShowModal(false);
            getAppointment();
            return;
          } else {
            console.log('FAILED REQUEST');
            return;
          }
        });
  };

  return (
    <>
      <NotificationAlert ref={notificationAlertRef}/>
      <Modal
        className="modal modal-primary"
        show={showModal}
        onHide={() => {
          if (!loading) {
            setShowModal(false);
          }
        }}
        onSubmit={DeleteAppointment}
        autoFocus={false}
        enforceFocus={false}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon nc-notes"></i>
          </div>
        </Modal.Header>
        {!loading ?
          <div className="modal-body">
            <p className="text-center">{t(translations.APPOINTMENT_DELETE)} {showVisitor} {t(translations.APPOINTMENT_COMMENT2)} {showDate} {t(translations.APPOINTMENT_COMMENT3)}{showHour}?</p>
            <Form>
              <Col style={{flex: 1}}>
                <Button className="btn-fill btn-round col-sm-6" type="submit">{t(translations.DELETE)}</Button>
                <Button className="btn-fill btn-round col-sm-6" onClick={() => {
                  setShowModal(false);
                }}>{t(translations.CANCEL)}</Button>
              </Col>
            </Form>
          </div> :
          <div className="modal-body" style={{alignItems: 'center', justifyContent: 'center', width: '100%', display: 'flex'}}>
            <CircularProgress style={{color: '#F6B540'}}/>
          </div>
        }
      </Modal>
    </>
  );
};

export default ModalDELETETableList;
